import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    if (!localStorage.getItem("pinpoint_token")) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCompany(data.company);
    } catch (e) {
      localStorage.removeItem("pinpoint_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pinpoint_token", data.token);
    setUser(data.user);
    await checkAuth();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("pinpoint_token", data.token);
    setUser(data.user);
    await checkAuth();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("pinpoint_token");
    setUser(null);
    setCompany(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, company, loading, login, register, logout, setUser, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const homeFor = (role) =>
  role === "landlord" ? "/landlord" :
  role === "tenant" ? "/tenant" :
  role === "contractor" ? "/contractor" : "/dashboard";
